import ProfileManageBasic from './ProfileManageBasic';

export default ProfileManageBasic;
